(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["getsup-delivery-quote"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('getsup-quote-link')) {
    customElements.define('getsup-quote-link', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.addEventListener('click', (event) => {
          const link = event.target.closest('a');
          const form = document.getElementById(this.dataset.formId);
          if (!link || !form) return;
          const fields = new FormData(form);
          const variants = JSON.parse(this.dataset.variants || '[]');
          const variant = variants.find((entry) => String(entry.id) === String(fields.get('id')));
          const url = new URL(link.href);
          const scope = this.closest('[id^="shopify-section-"]') || form;
          const quantityInput = Array.from(scope.querySelectorAll('input[name="quantity"]')).find((input) => input.getClientRects().length > 0 && getComputedStyle(input).visibility !== 'hidden');
          const quantity = Math.max(1, Number(quantityInput ? quantityInput.value : fields.get('quantity')) || 1);
          url.searchParams.set('quantity', String(quantity));
          if (variant) {
            url.searchParams.set('variant', variant.title);
            url.searchParams.set('sku', variant.sku || '');
            const productUrl = new URL(url.searchParams.get('product_url'));
            productUrl.searchParams.set('variant', String(variant.id));
            url.searchParams.set('product_url', productUrl.href);
          }
          link.href = url.href;
        });
      }
    });
  }
  if (!customElements.get('getsup-quote-receiver')) {
    customElements.define('getsup-quote-receiver', class extends HTMLElement {
      connectedCallback() {
        const params = new URLSearchParams(location.search);
        const mode = params.get('freight');
        if (mode !== 'product' && mode !== 'cart') return;
        const setIfEmpty = (id, value) => {
          const field = document.getElementById(id);
          if (field && !field.value) field.value = value;
        };
        let summary = '';
        if (mode === 'cart') {
          summary = this.dataset.cartSummary.trim();
          if (!summary) return;
          setIfEmpty('GetSupContactProduct', this.dataset.cartTitle);
        } else {
          const title = (params.get('product') || '').slice(0, 500);
          const variant = (params.get('variant') || '').slice(0, 500);
          const sku = (params.get('sku') || '').slice(0, 200);
          const quantity = Math.max(1, Math.min(1000000, Number(params.get('quantity')) || 1));
          if (!title) return;
          const detail = [String(quantity) + ' × ' + title, variant === 'Default Title' ? '' : variant, sku].filter(Boolean).join(' — ');
          setIfEmpty('GetSupContactProduct', title);
          setIfEmpty('GetSupFreightQuantity', detail);
          summary = detail;
          try {
            const productUrl = new URL(params.get('product_url'));
            if (productUrl.origin === location.origin && productUrl.pathname.includes('/products/')) summary += '\n' + productUrl.href;
          } catch (_) {}
        }
        setIfEmpty('GetSupFreightPreference', 'Delivery quote');
        setIfEmpty('GetSupContactMessage', this.dataset.requestLabel + '\n' + summary);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
